export class PluralizeValueConverter {
	toView(value: string, itemCount: number, pluralForm: string): string {
		if (itemCount === 1) { return value; }

		if (value.length === 0) { return value; }

		if (pluralForm) { return pluralForm; }

		let last = value[value.length - 1];
		if (last === 's' || last === 'x' || last === 'z') {
			return value + "es";
		} else {
			return value + "s";
		}
	}
}
